// based on https://github.com/vue-bulma/click-outside

function validate(binding) {
  if (typeof binding.value !== 'function') {
    console.warn(
      '[ClickOutside] provided expression',
      binding.expression,
      'is not a function.'
    );
    return false;
  }

  return true;
}

function isServer(vNode) {
  return (
    typeof vNode.componentInstance !== 'undefined' &&
    vNode.componentInstance.$isServer
  );
}

var ClickOutside = {
  bind: function(el, binding, vNode) {
    if (!validate(binding)) return;

    // Define Handler and cache it on the element
    function handler(e) {
      if (!vNode.context) return;

      if (
        !(
          el &&
          el !== e.target &&
          (e.composedPath
            ? !e.composedPath().includes(el)
            : !el.contains(e.target))
        )
      ) {
        return;
      }

      var elements = e.path || (e.composedPath && e.composedPath());
      elements && elements.length > 0 && elements.unshift(e.target);

      el.__vueClickOutside__.callback(e);
    }

    // add Event Listeners
    el.__vueClickOutside__ = {
      handler: handler,
      callback: binding.value
    };
    const clickHandler =
      'ontouchstart' in document.documentElement ? 'touchstart' : 'click';
    !isServer(vNode) && document.addEventListener(clickHandler, handler);
  },

  update: function(el, binding) {
    if (validate(binding)) el.__vueClickOutside__.callback = binding.value;
  },

  unbind: function(el, binding, vNode) {
    // Remove Event Listeners
    const clickHandler =
      'ontouchstart' in document.documentElement ? 'touchstart' : 'click';
    !isServer(vNode) &&
      el.__vueClickOutside__ &&
      document.removeEventListener(
        clickHandler,
        el.__vueClickOutside__.handler
      );
    delete el.__vueClickOutside__;
  }
};

export default ClickOutside;
